import { Component, Directive, EventEmitter, Inject, OnDestroy, OnInit } from '@angular/core';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMetaDataListCardConfigData, DwOrmDataService, DwOrmDataServiceToken, formatDateTime, formatDateTimeToLocal } from '@devwareapps/devware-cap';

import * as moment_ from 'moment';
import { JobTimerQueryEntity } from '../../meta-data/extensions/job-timer-query-entity.model';
import { TimerEntity, TimersMetaDataItemNames, TimerStatusAllItems, TimerTypeAllItems } from '../../meta-data/timers-meta-data.service';
import { TimerConfig } from '../../models/timer-config.model';
import { TimerUtilService } from '../../services/timer-util.service';
import { TimerCardConfigComponent } from '../timer-card-config/timer-card-config.component';

@Directive()
export abstract class TimerCardBaseComponent<TimerEntityType extends TimerEntity=TimerEntity> implements DwCardBaseComponent<TimerConfig, TimerEntityType>, OnInit, OnDestroy {
  cardConfig?: TimerConfig;
  data?: TimerEntityType;
  cardClick: EventEmitter<any> = new EventEmitter();
  resolvedContext?: any;

  intervalHandle: any;

  timeLeftDisplay: string = "";
  cardClass?: string;

  isHover: boolean = false;
  showComplete: boolean = false;
  timeLeftInSeconds: number;

  buttonVisibility: {
    hideButtons?: boolean,
    showStart?: boolean,
    showStop?: boolean,
    showReset?: boolean
  } = {};

  titleDisplay: string = '';
  titleTooltip: string = '';
  dateDisplay: string = '';

  constructor(@Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
    protected timerUtilService: TimerUtilService) {
  }


  abstract countUp(): boolean;
  abstract getReferenceDate(timer: TimerEntityType): string;
  abstract setupCardData(timer: TimerEntityType);


  onMouseEnter() {
    this.isHover = true;
  }

  onMouseExit() {
    this.isHover = false;
  }

  setupCard() {
    this.setupCardData(this.data);
    this.updateTimer();

    if (this.data.TimerStatusId == TimerStatusAllItems.Complete) {
      this.showComplete = false;
    } else {
      this.showComplete = true;
    }

    this.intervalHandle = setInterval(() => {
      this.updateTimer();
    }, 200);
  }

  // switch (this.data.TimerTypeId) {
  //   case TimerTypeAllItems.JobTimer:
  //     const jobTimerEntity = this.data as JobTimerQueryEntity;

  //     this.titleDisplay = this.data.Ethos_JobIdDisplay || 'No Job Assigned';
  //     if (jobTimerEntity.EthosAddressCity && jobTimerEntity.EthosAddressStateProvinceIdDisplay) {
  //       this.titleTooltip = `${jobTimerEntity.EthosAddressCity}, ${jobTimerEntity.EthosAddressStateProvinceIdDisplay}`;
  //     }

  //     if (this.data.DueDateTime) {
  //       this.dateDisplay = `Due at ${formatDateTimeToLocal(this.data.DueDateTime, true, true)}`;
  //     }


  //     break;
  //   case TimerTypeAllItems.TechTimer:
  //     this.titleDisplay = this.data.TechEthos_UserIdDisplay || 'No Resource Assigned';

  //     if (this.data.StartDateTime) {
  //       this.dateDisplay = `Available since ${formatDateTimeToLocal(this.data.StartDateTime, true, true)}`;
  //     }
  //     break;
  // }
  //}




  // if (this.data.TimerTypeId == TimerTypeAllItems.JobTimer) {
  //   const jobTimerEntity = this.data as JobTimerQueryEntity;

  //   this.titleDisplay = this.data.Ethos_JobIdDisplay || 'No Job Assigned';
  //   if (jobTimerEntity.EthosAddressCity && jobTimerEntity.EthosAddressStateProvinceIdDisplay) {
  //     this.titleTooltip = `${jobTimerEntity.EthosAddressCity}, ${jobTimerEntity.EthosAddressStateProvinceIdDisplay}`;
  //   }

  //   if (this.data.DueDateTime) {
  //     this.dateDisplay = `Due at ${formatDateTime(this.data.DueDateTime, true, true)}`;
  //   }

  // } else {
  //   this.titleDisplay = this.data.TechEthos_UserIdDisplay || 'No Resource Assigned';

  //   if (this.data.StartDateTime) {
  //     this.dateDisplay = `Available since ${formatDateTime(this.data.StartDateTime, true, true)}`;
  //   }
  // }





  click() {
    this.cardClick.emit(this.data);
  }

  timeLeftAdjustment(): number {
    return 0;
  }


  updateTimer() {


    // Calculate the time left
    const dateValue = this.getReferenceDate(this.data);
    this.timeLeftInSeconds = this.timerUtilService.getCurrentCountdownValue(this.data, dateValue, this.countUp(), this.timeLeftAdjustment());

    // Determine the card class
    this.cardClass = this.timerUtilService.getCurrentTimerClass(this.data, this.cardConfig, this.timeLeftInSeconds);

    switch (this.data.TimerStatusId) {
      case TimerStatusAllItems.Stopped:
        this.timeLeftDisplay = "Stopped";
        this.buttonVisibility = {
          showStart: true
        }
        return;
      case TimerStatusAllItems.Complete:
        this.timeLeftDisplay = "Complete";
        this.buttonVisibility = {
          hideButtons: true,
        };
        return;
    }
    // if (this.data.TimerStatusId == TimerStatusAllItems.Complete) {
    //   this.timeLeftDisplay = "Complete";
    //   this.buttonVisibility = {
    //     hideButtons: true,
    //   };
    //   return;
    // }

    // if (!this.timeLeftInSeconds && this.timeLeftInSeconds !== 0) {
    //   this.timeLeftDisplay = "Stopped";
    //   this.buttonVisibility = {
    //     showStart: true
    //   }
    //   return;
    // }

    this.buttonVisibility = {
      showReset: true,
      showStop: true
    }

    // Format the time left for display (days + hours:minutes:seconds)
    this.timeLeftDisplay = this.timerUtilService.formatDuration(this.timeLeftInSeconds);

    // Check auto-complete
    if (this.cardConfig.autoCompleteAfterMinutes) {

      let minutesPast = this.timeLeftInSeconds / 60;

      if (!this.countUp()) {
        minutesPast = -minutesPast;
      }
      // switch (this.data.TimerTypeId) {
      //   case TimerTypeAllItems.JobTimer:
      //     minutesPast = -minutesPast;

      //     break;
      // }

      if (minutesPast > this.cardConfig.autoCompleteAfterMinutes) {
        this.completeTimer();
      }

    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.intervalHandle) {
      clearInterval(this.intervalHandle);
    }
  }

  completeTimer() {
    this.data.TimerStatusId = TimerStatusAllItems.Complete;

    this.save();
  }

  start(): void {
    const referenceDate = this.getReferenceDate(this.data);

    if (!referenceDate) {
      this.reset();
    }

    this.data.TimerStatusId = TimerStatusAllItems.Active;

    this.save();
  }

  stop(): void {
    this.data.TimerStatusId = TimerStatusAllItems.Stopped;
    
    this.save();
  }

  reset(): void {
    this.data.TimerStatusId = TimerStatusAllItems.Active;

    this.save();
  }
  
  openWindow(url: string, event: Event) {
    window.open(url,"_blank");

    if (event?.preventDefault) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  private save() {
    
    this.ormDataService.saveEntity(this.data)
      .subscribe(newData => {
        // No need to update date since the save triggers the list to refresh
        // this.data = newData;

        // this.setupCardData(newData);

        // this.updateTimer();
      })
  }
}